import React from 'react'
import styles from './Aproval.module.css'
import { FaHome } from 'react-icons/fa';
import adlogo from '../Images/AdManagerLogo.png'
import { Link } from "react-router-dom";
import companyLogo from "../Images/CompanyLogo.png"

const Aproval = () => {
    return (
        <>
            <div className={styles.home}>
                <div className={styles.side}>
                    <div>
                        <Link to="/home" className={styles.homeTitle}>
                            <FaHome size={22} className={styles.logo} />
                            <div className={styles.text}>Home</div>
                        </Link>
                        <Link to="/admanager" className={styles.manager}>
                            <div className={styles.admanag}><img src={adlogo} alt="" /></div>
                            <div className={styles.text}>Ads screening</div>
                        </Link>
                    </div>
                </div>
                <div className={styles.right}>
                    <div className={styles.inner}>
                        <div className={styles.cards}>
                            <div className={styles.card1}>
                                <div className={styles.companyname}>
                                    <img src={companyLogo} alt="" className={styles.comLogo} />
                                    <div className={styles.title}>Company name</div>
                                </div>
                                <div className={styles.airdrop}>Airdrop 10 $TTH tokens</div>
                                <div className={styles.companyDetail}>Go to our website and join our free 10$TTH giveaway. You only need to to fill out the form and leave your wallet address.</div>
                                <div className={styles.go}>Go to</div>
                                <input type="text" placeholder='Enter promotion'  className={styles.prom}/>
                                <button className={styles.accept}>Accept</button> 
                                <button className={styles.decline}>Decline</button> 

                            </div>
                            <div className={styles.card1}>
                                <div className={styles.companyname}>
                                    <img src={companyLogo} alt="" className={styles.comLogo} />
                                    <div className={styles.title}>Company name</div>
                                </div>
                                <div className={styles.airdrop}>Airdrop 10 $TTH tokens</div>
                                <div className={styles.companyDetail}>Go to our website and join our free 10$TTH giveaway. You only need to to fill out the form and leave your wallet address.</div>
                                <div className={styles.go}>Go to</div>
                                <input type="text" placeholder='Enter promotion'  className={styles.prom}/>
                                <button className={styles.accept}>Accept</button> 
                                <button className={styles.decline}>Decline</button> 

                            </div>
                            <div className={styles.card1} style={{marginRight:"1.12%"}}>
                                <div className={styles.companyname}>
                                    <img src={companyLogo} alt="" className={styles.comLogo} />
                                    <div className={styles.title}>Company name</div>
                                </div>
                                <div className={styles.airdrop}>Airdrop 10 $TTH tokens</div>
                                <div className={styles.companyDetail}>Go to our website and join our free 10$TTH giveaway. You only need to to fill out the form and leave your wallet address.</div>
                                <div className={styles.go}>Go to</div>
                                <input type="text" placeholder='Enter promotion'  className={styles.prom}/>
                                <button className={styles.accept}>Accept</button> 
                                <button className={styles.decline}>Decline</button> 

                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default Aproval
